import './App.css';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import NavBar from './NavBar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ArticlesListPage from './pages/ArticlesListPage';
import ToolsListPage from './pages/ToolsListPage';
import ArticlePage from './pages/ArticlePage';
import ToolPage from './pages/ToolPage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/LoginPage';
import CreateAccountPage from './pages/CreateAccountPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ForgotPasswordRedirectPage from './pages/ForgotPasswordRedirectPage';

// Make the frontend and backend think they are running on the same origin by setting up a proxy in the package.json file. ("http://localhost:8000/")
function App() {
  return (

      <div className="App">
        <NavBar/>
        <div id="page-body">
          <Routes>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/about" element={<AboutPage/>}/>
            {/* <Route path="/articles" element={<ArticlesListPage/>}/>
            <Route path="/articles/:articleId" element={<ArticlePage/>}/> */}
            <Route path="/tools" element={<ToolsListPage/>}/>
            <Route path="/tools/:toolId" element={<ToolPage/>}/>
            <Route path="/login" element={<LoginPage/>}/>
            <Route path="/create-account" element={<CreateAccountPage/>}/>
            <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
            <Route path="/reset-password/auth/action" element={<ForgotPasswordRedirectPage/>}/>
            <Route path="*" element={<NotFoundPage/>} />
          </Routes>
        </div>
      </div>

  );
}

export default App;
